import fetchClient from '../components/common/FetchClient';

const requestCustomersType = 'REQUEST_CUSTOMER_SEARCH';
const receiveCustomersType = 'RECEIVE_CUSTOMER_SEARCH';
const initialState = { customers: [], isLoading: false, keywords: '', selectedCustomer: '' };

export const actionCreators = {
    searchCustomers: keywords => async (dispatch, getState) => {
        if (keywords === getState().customerSearch.keywords) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        getState().customerSearch.keywords = keywords;

        dispatch({ type: requestCustomersType, keywords });

        var customers = [];

        //var token = ""; // fill in a token here later from local session storage

        const url = `api/Customers/GetCustomers`;
        await fetchClient(url, {
            params: {
                azureToken: '',
                keywords: keywords
            }
        }).then(function (resp) {
            console.log(resp);
            if (resp) {
                customers = resp.json();

                dispatch({ type: receiveCustomersType, keywords, customers });
            }
        });
    }
};

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === requestCustomersType) {
        return {
            ...state,
            keywords: action.keywords,
            isLoading: true
        };
    }

    if (action.type === receiveCustomersType) {
        return {
            ...state,
            keywords: action.keywords,
            customers: action.customers,
            isLoading: false
        };
    }

    return state;
};



// WEBPACK FOOTER //
// ./src/store/CustomerSearch.js